/***
** Bumil, Busui.
** Daily Best Paket 1, Daily Best Paket 4, Daily Best Paket 8.
*/

var CartDelivery = function () {

    var item;
    var cardParent;
    var cardTemplate;
    var deliveryTemplate;
    var deliveryTemplateParent;
    var isChangingCart = false;

    var prepare = function (card, options) {
        $(card).find('.trash-icon').click(remove);
        $(card).find('.subscribe-delivery-index').html($(card).index() + 1);
        $(card).find('input.subscribe-delivery-date').change(updateDate);
        $(card).find('select.select-satuan').change(updateDateProduct);
    };
    function removeA(arr) {
        var what, a = arguments, L = a.length, ax;
        while (L > 1 && arr.length) {
            what = a[--L];
            while ((ax = arr.indexOf(what)) !== -1) {
                arr.splice(ax, 1);
            }
        }
        return arr;
    }
    function updateListSelected(element, quantity, prevQuantity) {
        var isReplace = false;
        if (quantity == 'R') {
            quantity = 0;
            isReplace = true;
        }
        var section = element.parents('section');
        var listProduct = section.find('.listProduct').val();
        var date = section.find('.subscribe-delivery-date').val();
        var select = element.parents('.subscribe-product').find('.select-satuan');
        var prevText = select.val() + ' x ' + prevQuantity + ' x ' + date;
        var newText = select.val() + ' x ' + quantity + ' x ' + date;
        if (prevQuantity == 0 && quantity == 1) {
            // ADDING
            listProduct = '' == listProduct ? newText : listProduct + ', ' + newText;
        } else if (prevQuantity >= 1 && quantity >= 1) {
            // EDITING
            listProduct = listProduct.replace(prevText, newText);
        } else {
            // DELETING
            // value yg di delete akan selalu value x1. akan teteapi masih ada koma di belakangnya
            var find = ', ';
            var re = new RegExp(find, 'g');
            listProduct = listProduct.replace(re, ',');
            var listProductArr = listProduct.split(',');
            if (listProductArr.length == 1) {
                listProduct = '';
            } else {
                var lastValue = select.attr('data-lastValue');
                if (isReplace && lastValue != '') {
                    // Replacing
                    listProductArrNew = removeA(listProductArr, lastValue + ' x ' + prevQuantity);
                    select.attr('data-lastValue', select.val());
                }
                listProductArrNew = removeA(listProductArr, prevText);
                listProduct = listProductArrNew.join(', ')
            }
        }
        section.find('.listProduct').val(listProduct);
        element.attr('data-lastValue', element.val());
    }

    var updateDate = function () {
        // Date validation, won't continue if same date is selected
        var T = $(this);
        var section = T.parents('section');
        var isSameDate = false;
        $('.date-selected').not(section).each(function () {
            if (T.val() == $(this).find('.subscribe-delivery-date').val()) {
                sameDateSelected(T);
                isSameDate = true;
                return;
            }
        })
        var dateInput = section.find('input[name="qty"]');
        var listProduct = T.siblings('.listProduct');
        var index = section.find('.subscribe-delivery-index').text();
        if (isSameDate == false) {
            if (T.hasClass('ajax-ready')) {
                listProduct.attr('name', 'properties[Tanggal Kirim/Pick Up Ke-' + index + ']');
                changeDate(T);
            } else {
                listProduct.attr('name', 'Tanggal Antar Ke-' + index);
            }
            // Handle langganan-paket-bumil, Busui dan best
            var dateSplit = T.val().split('/');
            var d = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
            var date = new Date(d);
            if (item.subscribeName == 'langganan-paket-busui') {
                displayProductBusui(T, date.getDay());
            } else if (item.subscribeName == 'langganan-paket-bumil') {
                displayProductBumil(T, date.getDay());
            } else {
                // Newest langganan
                displayProductBestPaket(T, date.getDate());
            }

            section.attr('data-date', T.val());
            section.addClass('date-selected');
        }
        updateAssigned();
    };

    var updateDateProduct = function () {
        // Date validation, won't continue if same date is selected
        var section = $(this).parents('section');
        var T = section.find('input.subscribe-delivery-date');
        var isSameDate = false;
        $('.date-selected').not(section).each(function () {
            if (T.val() == $(this).find('.subscribe-delivery-date').val()) {
                sameDateSelected(T);
                isSameDate = true;
                return;
            }
        })
        var dateInput = section.find('input[name="qty"]');
        var listProduct = T.siblings('.listProduct');
        var index = section.find('.subscribe-delivery-index').text();
        if (isSameDate == false) {
            if (T.hasClass('ajax-ready')) {
                listProduct.attr('name', 'properties[Tanggal Kirim/Pick Up Ke-' + index + ']');
                changeDate(T);
            } else {
                listProduct.attr('name', 'Tanggal Antar Ke-' + index);
            }
            // Handle langganan-paket-bumil, Busui dan best
            var dateSplit = T.val().split('/');
            var d = dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0]
            var date = new Date(d);
            displayProductBestPaket(T, date.getDate());

            section.attr('data-date', T.val());
            section.addClass('date-selected');
        }

        langgananChangeDate(T, 1);
        updateAssigned();
    };

    var dateValid = false;
    var updateAssigned = function () {
        var assigned = 0;
        dateValid = true;
        deliveryTemplateParent.empty();
        $('.np-pengiriman-card select.select-satuan').each(function () {
            var product = $(this);
            var parent = product.closest('.np-pengiriman-card');
            var date = parent.find('input[name*="date"]').val();
            var multiplier = product.children(':selected').attr('data-bottles');
            multiplier = !isNaN(multiplier) && multiplier != '' ? parseInt(multiplier) : 0;

            var quantity = product.parent().find('input[name*=qty]').val();
            quantity = !isNaN(quantity) && quantity != '' ? parseInt(quantity) : 0;
            assigned += (quantity * multiplier);
            if (moment(date, 'DD-MM-YYYY', true).isValid()) {
                if ((quantity * multiplier) > 0) {
                    var summaryCard = deliveryTemplateParent.children('[data-date="' + date + '"]');
                    if (summaryCard.length == 0) {
                        var summaryCard = deliveryTemplate.clone(true);
                        summaryCard.attr('data-date', date);
                        summaryCard.find('.subscribe-popup-date').html(date);
                        summaryCard.find('.subscribe-popup-product').html(product.children(':selected').html());
                        summaryCard.find('.subscribe-popup-quantity').html(quantity);
                        deliveryTemplateParent.append(summaryCard);
                    }
                    else {
                        var detailsCard = summaryCard.find('.subscribe-popup-product:first').parent();
                        var detailsParent = detailsCard.parent();
                        detailsCard = detailsCard.clone(true);
                        detailsCard.find('.subscribe-popup-date').html(date);
                        detailsCard.find('.subscribe-popup-product').html(product.children(':selected').html());
                        detailsCard.find('.subscribe-popup-quantity').html(quantity);
                        detailsParent.append(detailsCard);
                    }
                }
            }
            else {
                dateValid = false;
            }
        });
        $('.subscribe-assigned').html(assigned);
        $('#total-botol').val(assigned);
        $('.jumlah-pengantaran').html($('section.date-selected').length);
        $('.subscribe-assigned').attr('data-current-bottles', assigned);
        var percent = assigned / item.bottles * 100;
        $('.np-bg-green-pop.np-progressbar').css({
            width: (percent > 100 ? 100 : percent) + '%'
        });
        if (percent == 100 && dateValid) {
            $('#subscribe-popup').modal({
                escapeClose: false,
                clickClose: false,
                showClose: false,
                fadeDuration: 100
            });
        }
        return percent;
    };

    var remove = function () {
        var card = $(this).closest('.np-pengiriman-card');
        next = card.nextAll();
        card.remove();

        next.each(function () {
            $(this).find('.subscribe-delivery-index').html($(this).index() + 1);
        });

        updateAssigned();
    };
    function progressMoreThanHundred(element) {
        if (element.hasClass('select-satuan')) {
            var justSelectedBottles = element.find('option:selected').attr('data-bottles');
        } else {
            var justSelectedBottles = element.parents('.subscribe-product').find('select.select-satuan option:selected').attr('data-bottles');
        }
        var currentBottles = parseInt($('.subscribe-assigned').attr('data-current-bottles')) - justSelectedBottles;
        var neededBottles = item.bottles - currentBottles;
        $('#modal-text .text-terpilih').text(justSelectedBottles);
        $('#modal-text .text-kurang').text(neededBottles + ' lagi');
        0 != neededBottles && demoModal.open();
    }
    function progressIsHundred() {
        //$('.select-satuan').attr('disabled', 'disabled');
        $('.subscribe-increase').addClass('disabled');
        $('.botol-terpenuhi').removeClass('dn');
        $('.subscribe-decrease').addClass('full-mode-actived')
    }
    function progressNotHundred() {
        $('.subscribe-increase').removeClass('disabled');
        $('.botol-terpenuhi').addClass('dn');
        $('.subscribe-decrease').removeClass('full-mode-actived')
        // Should create new element
        $('.subscribe-selection .subscribe-product:last-child').removeClass('dn');
        $('section.np-pengiriman-card:not(.date-selected)').removeClass('dn').addClass('db');
    }
    function displayProductBusui(element, day) {
        var package1 = 'Summer Passion · Silk · Green Grenade · Endless Summer';
        var package2 = 'Green Grenade · Jade · Sweet Green · Endless Summer';
        var package3 = 'Cara Mia · Sunrise · Lean Green · Endless Summer';
        element.parents('section').find('input[name="qty"]').val(1);
        if (day == 0 || day == 1 || day == 6) {
            element.siblings('p.product_bumil_busui').text(package1);
            element.siblings('.listProduct').val(package1 + ' x 1 x ' + element.val());
        } else if (day == 2 || day == 3) {
            element.siblings('p.product_bumil_busui').text(package2);
            element.siblings('.listProduct').val(package2 + ' x 1 x ' + element.val());
        } else {
            element.siblings('p.product_bumil_busui').text(package3);
            element.siblings('.listProduct').val(package3 + ' x 1 x ' + element.val());
        }
    }
    function displayProductBumil(element, day) {
        var package1 = 'Sweet Green · Endless Summer · Summer Passion · Silk';
        var package2 = 'Green Grenade | Heart Beet · Sweet Green · Jade';
        var package3 = 'First Kiss · Sunrise · Endless Summer · Cara Mia';
        element.parents('section').find('input[name="qty"]').val(1);
        if (day == 0 || day == 1 || day == 6) {
            element.siblings('p.product_bumil_busui').text(package1);
            element.siblings('.listProduct').val(package1 + ' x 1 x ' + element.val());
        } else if (day == 2 || day == 3) {
            element.siblings('p.product_bumil_busui').text(package2);
            element.siblings('.listProduct').val(package2 + ' x 1 x ' + element.val());
        } else {
            element.siblings('p.product_bumil_busui').text(package3);
            element.siblings('.listProduct').val(package3 + ' x 1 x ' + element.val());
        }
    }

    function displayProductBestPaket(element, day) {

        //var odd = 'Morning Dew · Kurma Seed Granola · Blondie';
        //var even = 'Chia Seed Pudding · Red Earth · Walnut Overnight Oat';

        var odd = element.parents('section').find('select.select-satuan').val();

        element.parents('section').find('input[name="qty"]').val(1);
        element.siblings('p.product_bumil_busui').text(odd);
        element.siblings('.listProduct').val(odd + ' x 1 x ' + element.val());

    }


    function changeDate(elm) {
        var newDate = elm.val();
        var oldDate = elm.parents('section').attr('data-date');
        var productList = elm.siblings('.listProduct');

        var re = new RegExp(oldDate, 'g');
        listProduct = productList.val().replace(re, newDate);
        productList.val(listProduct);
    }
    function langgananEdit(element) {
        var C = element,
            F = C.parents("form"),
            count = C.parents('.subscribe-product').find('input[name="qty"]').val();
        $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: F.serialize(),
            dataType: "json",
            beforeSend: function () {
                C.parents('section.np-pengiriman-card').addClass('loading');
                if (C.hasClass('select-satuan')) {
                    var prevSelect = C.parents('.subscribe-product').siblings(':not(:last-child)').find('.select-satuan');
                    prevSelect.attr('disabled', 'disabled');
                }
            },
            complete: function () {
                C.parents('section.np-pengiriman-card').find('.subscribe-delivery-date').addClass('ajax-ready');
            },
            success: function (E) {
                $('section.np-pengiriman-card').removeClass('loading');
                // From id change to line.key
                var keyContainer = F.find('input[name=id]');
                var productHandle = keyContainer.attr('data-handle');
                for (var i = 0; i < E.items.length; i++) {
                    if (E.items[i].handle == productHandle) {
                        keyContainer.val(E.items[i].key)
                    }
                }
                var percent = updateAssigned();
                0 == count && C.parents('.subscribe-product').remove();
                100 == percent && progressIsHundred();
                true == C.hasClass('full-mode-actived') && progressNotHundred();
                updateDrawerLangganan();
                updateDrawerNonLangganan();
            },
            error: function (I, P) {
            }
        })
    }
    $(document).on("change", ".subscribe-delivery-date.ajax-ready", function (y) {
        var parent = $(this).parents('section.np-pengiriman-card');
        langgananChangeDate(parent, 1);
    });
    // Remove this product's existing line(s) from the cart, then add it again
    // with the current form data. Lines are looked up from /cart.js first:
    // /cart/change.js returns 400 for an id that is not in the cart (e.g. the
    // product has not been added yet while other items are in the cart).
    function langgananChangeDate(elm, bool) {
        if (isChangingCart) return; // Guard
        isChangingCart = true;

        var id = $('input[name=id]').val(),
            D = $('form#main-langganan-form');
        var variantId = id.split(':')[0];

        elm.addClass('loading');

        var fail = function (E) {
            isChangingCart = false;
            elm.removeClass('loading');
            console.error('langgananChangeDate failed:', E.responseJSON || E.responseText || E);
        };

        $.ajax({
            type: "GET",
            url: "/cart.js",
            dataType: "json",
            cache: false,
            error: fail,
            success: function (cartData) {
                var updates = {};
                var hasExisting = false;
                $.each(cartData.items, function () {
                    if (this.key == id || this.id == variantId) {
                        updates[this.key] = 0;
                        hasExisting = true;
                    }
                });

                var addAgain = function () {
                    true == bool ? elm.removeClass('loading') : elm.remove();
                    // add.js only work with variant id.
                    $('input[name=id]').val(variantId);
                    doAddToCart(D, elm);
                };

                if (!hasExisting) {
                    addAgain();
                    return;
                }

                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    data: { updates: updates },
                    dataType: "json",
                    error: fail,
                    success: addAgain
                });
            }
        });
    }

    function doAddToCart(D, elm) {
        $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: true,
            cache: false,
            data: D.serialize(),
            dataType: "json",
            error: function (T) {
                isChangingCart = false;
                console.error('doAddToCart failed:', T.responseJSON || T.responseText || T);
            },
            success: function (T) {
                $('input[name=id]').val(T.key);
                D.removeClass('loading');
                updateDrawerLangganan();
                updateDrawerNonLangganan();
                isChangingCart = false; // Reset flag setelah selesai

                $.ajax({
                    type: "GET",
                    url: "/cart.js",
                    cache: false,
                    dataType: "json",
                    success: function (K) {
                        var B = $('.np-cart-badge');
                        B.text(K.item_count);
                        B.attr('title', K.item_count);
                        var percent = updateAssigned();
                        100 == percent ? progressIsHundred() : progressNotHundred();
                    }
                });
            }
        });
    }

    function sameDateSelected(el) {
        $('#modal-text').html('Anda sudah memilih tanggal ini<br> Silahkan pilih tanggal lain');
        demoModal.open();
        var prevDate = el.parents('section').attr('data-date');
        var index = parseInt(el.parents('section').find('.subscribe-delivery-index').text()) - 1;
        if (prevDate != '') {
            el.val(prevDate);
            var fullDate = prevDate.split('/')
            var fullDateF = fullDate[2] + '-' + fullDate[1] + '-' + fullDate[0];
            picker[index].setDate(fullDateF);
        } else {
            el.val('');
            el.siblings('.listProduct').attr('name', '');
            //picker[index].setDate(null);
        }
    }

    return {
        init: function (itemData, options) {
            item = itemData;
            picker = item.pikaday;
            $('.subscribe-bottles').html(item.bottles).attr('data-total-bottles', item.bottles);
            $('.subscribe-max-delivery').html(item.maxDelivery);
            $('.np-pengiriman-card').each(function () {
                prepare(this, options);
            });
            cardParent = $('.np-pengiriman-card:first').parent();
            cardTemplate = $('.np-pengiriman-card:first').clone(true);
            cardTemplate.find('.tanggalDelete').removeClass('dn ajax-ready');
            cardTemplate.find('.subscribe-delivery-date').removeClass('ajax-ready');
            cardTemplate.find('.subscribe-product:not(:last-child)').remove();
            cardTemplate.find('input[name=id]').remove();
            $('#subscribe-container').show();


            //$('#subscribe-popup form').submit(checkout);
            deliveryTemplate = $('#subscribe-popup .np-popup-delivery-card:first');
            deliveryTemplateParent = deliveryTemplate.parent();
            deliveryTemplate.remove();

            var percent = updateAssigned();
            100 == percent ? progressIsHundred() : progressNotHundred();

            // Slots are pre-filled and locked with no user interaction
            // left to trigger the usual change-driven add-to-cart flow,
            // so add the item automatically on first visit.
            if (!item.inCart) {
                isChangingCart = true;
                doAddToCart($('form#main-langganan-form'));
            } else if (item.needsResync) {
                // Reopened an existing subscription whose locked schedule was
                // re-anchored to newer valid dates (past cutoff / past the
                // saved delivery date); push the correction back to the cart
                // line by removing the old line and re-adding with new dates.
                langgananChangeDate($('input.subscribe-delivery-date').first(), 1);
            }
        },
        remove: function () {

        },
        add: function (data, first) {
            if (first) {
                var card = $('.np-pengiriman-card:first');
                var details = card;

                // card.find('select').selectric();
            } else if (data && cardParent.children('[data-date="' + data.date + '"]').length == 1) {
                var card = cardParent.children('[data-date="' + data.date + '"]');

                var last = card.find('.subscribe-product:last');
                var details = last;
            } else {
                var card = cardTemplate.clone(true);
                card.removeClass('date-selected')
                card.find('input, select').val('');
                card.find('input[name*=qty]').val(0);
                cardParent.append(card);
                card.attr('data-date', card.find('input.subscribe-delivery-date').val());
                var newIndex = parseInt(card.index()) + 1;
                card.attr('id', 'step-' + newIndex);
                card.find('.select-satuan').removeClass('entry-date').attr('disabled', 'disabled');
                card.find('.select-satuan option').removeAttr('disabled', 'disabled');
                card.find('.listProduct').text('').val('');
                card.find('.listProduct').val('').attr('name', '');
                card.find('.subscribe-delivery-index').html(newIndex);
                card.find('input.subscribe-delivery-date').attr('data-step', newIndex);
                var details = card;
                d = new Date();
                var notAllowedDay = item.disabledDay;
                var min = item.cutOffTime <= d.getHours() ? d.setDate(d.getDate() + 2) : d.setDate(d.getDate() + 1);
                var max = new Date(min).setMonth(new Date(min).getMonth() + 3);
                var alreadySelectedDate = [];
                $('.date-selected').each(function () {
                    var fullDate = $(this).find('.subscribe-delivery-date').val().split('/')
                    var fullDateF = fullDate[2] + '-' + fullDate[1] + '-' + fullDate[0];
                    alreadySelectedDate.push(fullDateF);
                });
                var allDisabledDate = item.disabledDate;//.concat(alreadySelectedDate);
                picker[card.index()] = new Pikaday({
                    field: card.find('.subscribe-delivery-date')[0],
                    minDate: new Date(),
                    format: 'DD/MM/YYYY', keyboardInput: false,
                    minDate: new Date(min),
                    maxDate: new Date(max),
                    container: card.find('.pikaday-calendar')[0],
                    onSelect: function () {
                        //console.log($(this)[0].el.parents('section'));
                    },
                    disableDayFn: function (date) {
                        var dateFormated = moment(date).format('YYYY-MM-DD');
                        return (date.getDay() === notAllowedDay || allDisabledDate.indexOf(dateFormated) != -1);
                    }
                });

            }

            if (data) {
                details.find('input.subscribe-delivery-date').val(data.date);
                details.find('select.select-satuan').val(data.product).change();
                details.find('input[name*=qty]').val(data.quantity).change();
                card.attr('data-date', data.date);
            }

        }
    };
}();